module.exports = __webpack_public_path__ + "img/SJ.d6fb6a36.svg";